import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import './styles.scss';

interface Props {
  done?: boolean;
  label: string;
  selected?: boolean;
  step: number;
}

const CreateCampaignBreadcrumbItem: React.FC<Props> = ({
  done = false,
  label,
  selected = false,
  step,
}) => {
  const stepClassNames = classNames({
    step: true,
    selected: selected || done,
  });
  return (
    <div className="create-campaign-breadcrumb-item">
      <div className={stepClassNames}>{!done ? step : <FontAwesomeIcon icon={faCheck} />}</div>
      <div className="label">{label}</div>
    </div>
  );
};

export default CreateCampaignBreadcrumbItem;
